import { render, staticRenderFns } from "./AdverpeopleSection.vue?vue&type=template&id=0cf35e0e&"
import script from "./AdverpeopleSection.vue?vue&type=script&lang=js&"
export * from "./AdverpeopleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports